import { z } from 'zod/v3';
import { zObjectWithMeta } from '../../../common/utils';
import { transformNullish } from '../../../common/utils/schema/transformers/transformNullish';
import { transformToValidPeriod } from '../../../common/utils/schema/transformers/transformValidPeriod';
import { transformNull } from '../../../common/utils/schema/transformers/transformNull';
import { zIsoDate } from '../../../common/utils/schema/zIsoDate';
import { getSubCategoryTypeOneLetterCode } from '../../utils';
import { objectWithRandomUniqueKey } from '../../../common/utils/randomUniqueKey';

export const CategoryRelationFormDataSchema = transformToValidPeriod(
  z.object({
    id: z.number().nullable(),
    subCategoryCode: z.string(),
    subCategoryName: z.string().nullable(),
    subCategoryType: z.string(),
    sequenceNumber: z.number(),
    validFrom: zIsoDate().nullable(),
    validTo: zIsoDate().nullable(),
  }),
)
  .transform(({ subCategoryCode, subCategoryType, ...rest }) => ({
    ...rest,
    subCategory: subCategoryCode,
    subCategoryType: getSubCategoryTypeOneLetterCode(subCategoryType),
  }))
  // Workaround for known issue: https://github.com/colinhacks/zod/issues/2732
  .transform(
    (data) => data as Omit<typeof data, 'id'> & { readonly id: number | null },
  );

export const CategoryFormDataSchema = transformToValidPeriod(
  zObjectWithMeta(
    {
      id: z.number().nullable(),
      code: transformNull<string>(z.string(), ''),
      name: transformNull<string>(z.string(), ''),
      nameEng: transformNull<string>(z.string(), ''),
      description: transformNull<string>(z.string(), ''),
      categoryType: transformNull<string>(z.string(), ''),
      sequenceNumber: transformNull<number>(z.number(), '' as any),
      validFrom: zIsoDate().nullable(),
      validTo: zIsoDate().nullable(),
      inUse: transformNull(z.boolean(), false),
      categoryRelations: transformNullish<
        z.infer<typeof CategoryRelationFormDataSchema>[],
        z.input<typeof CategoryRelationFormDataSchema>[]
      >(z.array(CategoryRelationFormDataSchema), []),
      levelNumber: z.number(),
      parentCode: z.string().readonly().nullable(),
      childSequenceNumber: z.number(),
    },
    {
      addedInUi: z.boolean(),
    },
  ),
).transform(objectWithRandomUniqueKey);
